import { IS_GOOGLE_MAP_LOADED } from '@location/model';
import getPropFromModule from './getPropFromModule';

const getIsGoogleMapLoaded = state =>
  getPropFromModule(state, IS_GOOGLE_MAP_LOADED);

export default getIsGoogleMapLoaded;
